import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SagepayCloudPaymentCurrentNameComponentDef } from '@df/module-sagepay';

@Component({
    selector: 'sagepay-cloud-payment-current-name',
    template: '{{name}}',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SagepayCloudPaymentCurrentNameComponent extends SagepayCloudPaymentCurrentNameComponentDef {}
